// @ts-nocheck FIMXE
import config from "./config";
import * as utils from "./utils";

import * as customers from "./redux/modules/customers/reducer";
import * as workflow from "./redux/modules/workflow/actions";
import * as sites from "./redux/modules/sites/actions";
import * as route from "./redux/modules/route/actions";
import * as routeUtils from "./redux/modules/route/routes";
import store from "./storeInstance";

function initDebug(store: object): void {
  window.utils = utils;
  window.routeUtils = routeUtils;
  window.store = store;

  window.config = config;
  window.actions = { workflow, route, sites };
  window.reduxModules = { customers };
}

initDebug(store);
